import { render, staticRenderFns } from "./VirtualConcierge.vue?vue&type=template&id=01999764"
import script from "./VirtualConcierge.vue?vue&type=script&lang=js"
export * from "./VirtualConcierge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports